import axios from "axios";
import {
  getSessionId,
  getAffiliateId,
  getAffiliateSource,
  getCPLAffiliateHeaders,
  getEntrySource,
  getCheckInHeader,
} from "@/utils/getSessionId";
import { TYPED_ENV } from "@/utils/env";

export const apiClient = axios.create({
  baseURL: TYPED_ENV.VITE_API_BASE_URL,
  headers: {
    "X-Session-Id": getSessionId(),
    "X-affiliate": getAffiliateId(),
    "X-aff-source": getAffiliateSource(),
    "X-entry-source": getEntrySource(),
    "X-Check-In": getCheckInHeader(),
    ...getCPLAffiliateHeaders(),
  },
});
